import { useDispatch } from 'react-redux';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import DataGrid from 'app/components/DataGrid';
import usePurchases from 'app/hooks/usePurchases';

import {
  currencyOptions
} from 'app/utils/options';

import {
  getPurchases as exportPurchasesSvc
} from 'app/services/purchases';

const Purchases = props => {
  const {
    resource,
    onDataGridLoad,
    showFilters,
    getRowData,
    getFilterModel
  } = usePurchases();

  const exportCSV = () => {
    let params = {
      page: 0,
      per_page: 1000,
      is_export: true
    }

    const filterModel = getFilterModel();
    if (filterModel) {
      params.filter_model = filterModel;
    }

    exportPurchasesSvc(params).then((resp => resp.blob())).then((blob) => {
      const elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = `purchases_${new Date().toISOString()}.csv`;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    })
  }

  const header = 'Purchases';
  const columnOrder = ['transaction_date', 'customer_name', 'user_email', 'description', 'quantity', 'total', 'stripe_currency', 'job_name', 'access_code', 'discount_code'];
  const visibleColumns = [].concat(columnOrder);

  const columnDefOverrides = [
    { field: 'account_name', headerName: 'Account Name' },
    { field: 'job_name', headerName: 'Job Name' },
    { field: 'customer_name', headerName: 'Customer Name' },
    { field: 'access_code', headerName: 'Access Code' },
    { field: 'user_email', headerName: 'User Email' },
    {
      field: 'stripe_currency',
      headerName: 'Stripe Currency',
      inputType: 'select',
      inputOptions: currencyOptions
    },
    {
      field: 'transaction_date',
      headerName: 'Transaction Date',
      inputType: 'date',
      formatType: 'datetime'
    },
    { field: 'description' },
    { field: 'quantity', inputType: 'number' },
    {
      field: 'total',
      inputType: 'number',
      formatType: 'currency',
      getCurrency: data => data.stripe_currency
    }
  ]

  const buttons = [
    {
      key: 'export',
      icon: <FileDownloadIcon />,
      label: 'CSV',
      onClick: exportCSV
    }
  ]

  return (
    <DataGrid
      resource={resource}
      header={header}
      getRowData={getRowData}
      showFilters={showFilters}
      onDataGridLoad={onDataGridLoad}
      columnOrder={columnOrder}
      columnDefOverrides={columnDefOverrides}
      visibleColumns={visibleColumns}
      loadingMessage="Loading purchases..."
      buttons={buttons}
    />
  );
}

export default Purchases;
